/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum VersionFileListAliases {
  CONTEXTUAL_BAR_VERSION_FILE_LIST = 'contextual-bar-version-file-list',
  FETCH_VERSION_FILE_LIST = 'fetch-version-file-list',
  LAYOUT_VERSION_FILE_LIST = 'layout-version-file-list',
  PAGINATOR_VERSION_ITEM_FILE = 'paginator-version-item-file',
  PANEL_CONTENT = 'panel-content',
  TABLE_COLUMN_FILE_LAST_MODIFICATION = 'table-column-file-last-modification',
  TABLE_COLUMN_FILE_NAME = 'table-column-file-name',
  TABLE_COLUMN_VERSION_FILE_ACTIONS = 'table-column-version-file-actions',
  TABLE_VERSION_ITEM_FILE = 'table-version-item-file',
}
export { VersionFileListAliases };
